import React from "react";
import { Row, Col } from "react-flexbox-grid";

import Dialog, { DialogContent, DialogTitle } from "material-ui-next/Dialog";

import { Loadable, StyledButton } from "components/support";

const renderMessages = messages => {
  return messages.map((item, index) => (
    <Row center="xs" key={index} style={{ marginBottom: 20 }}>
      <Col>{item}</Col>
    </Row>
  ));
};

const LogsDialogView = ({ loading, open, onClose, content }) => {
  const { messages, fields } = content;

  return (
    <Dialog open={open} className="text-center">
      <Loadable loading={loading}>
        <DialogTitle>
          <span>Erros de importação do XML</span>
        </DialogTitle>
        <DialogContent>
          {renderMessages(messages)}
          {renderMessages(fields)}
          <Row className="layout-full-height" middle="xs">
            <Col xs>
              <div className="password-recovery-dialog">
                <StyledButton
                  flat
                  label="Confirmar"
                  type="button"
                  onClick={() => onClose()}
                />
              </div>
            </Col>
          </Row>
        </DialogContent>
      </Loadable>
    </Dialog>
  );
};

export default LogsDialogView;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/modify/xml/logs-dialog/index.js